<!-- <app-data-table [columns]="cols" [data]="systems" [title]="title"></app-data-table> -->


<ng-container>
  <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()" [url]="'/master/system-master'"
     [isDeletable]="'/master/system' | hasPermission: 'Delete'"  [showAddButton]="'/master/system' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/system' | hasPermission: 'Edit'"  [title]="title" (onAdd)="addSystem()" (editEventRow)="updateSystem($event)" [isView]="'/master/system' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
    (deleteEventRow)="showDeletePopup($event)" (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container>



<!-- Reusable Dialog for Add System -->
<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="addDialogConfig"
  [initialData]="{}"
  [viewMode]="false"
  (onSubmit)="onSubmitAdd($event)"
  (onCancel)="onCancelDialog()"
  (onClose)="onCloseDialog()"
></app-reusable-dialog>




<!-- Reusable Dialog for Update/View System -->
<app-reusable-dialog
  [(visible)]="isUpdatedialog"
  [config]="updateDialogConfig"
  [initialData]="selectedSystemData"
  [viewMode]="viewMode"
  (onSubmit)="onSubmitUpdate($event)"
  (onCancel)="onCancelDialog()"
  (onClose)="onCloseDialog()"
></app-reusable-dialog>


<p-dialog header="Delete System" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog  mt-3">
     <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete system ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
    </p-button>
  </div>
</p-dialog>